import React from 'react';
import * as S from './styles';

const CrossPromoContainer = (props = {}) => (
    <S.CrossPromoContainer
        border={props.border}
        height={props.height}
        margin={props.margin}
    >
        {props.children}
    </S.CrossPromoContainer>
);

export default CrossPromoContainer;
